import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface ReglageCercleProps extends pictoProps {
}

export interface ReglageCercleState extends pictoState {
}

export class ReglageCerclePicto extends Picto<ReglageCercleProps,ReglageCercleState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.reglageCerclePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(ReglageCerclePicto);
